/**
 * ground_targets.ts — shootable GROUND actors owned by other modules (the
 * air_targets pattern: physics-free, globalThis-backed so vite's dev-graph
 * module duplication can never split it).
 *
 * The bounty hunter's body has no server row and lives in BountyHunterModule;
 * WildsModule's ONE attack path (F / locked click / touch) reads this list to
 * pick among creatures, versonas, hunters and (pvp) players with the same
 * cone-and-reach rule, draws the shot to the mark, and calls the entry's own
 * `strike` — the reducer the owner knows how to report to.
 */
export interface GroundTarget {
  id: string;
  kind: 'hunter';
  label: string;
  x: number; y: number; z: number;
  /** Report the blow to the server (the owner's reducer). */
  strike: () => Promise<void>;
}

const store = (globalThis as unknown as { __atlasGroundTargets?: Map<string, GroundTarget> });
const targets: Map<string, GroundTarget> = store.__atlasGroundTargets ?? (store.__atlasGroundTargets = new Map());

export function upsertGroundTarget(t: GroundTarget): void {
  const cur = targets.get(t.id);
  if (cur) { cur.x = t.x; cur.y = t.y; cur.z = t.z; cur.label = t.label; cur.strike = t.strike; }
  else targets.set(t.id, t);
}

export function removeGroundTarget(id: string): void { targets.delete(id); }

export function groundTargetList(): GroundTarget[] { return [...targets.values()]; }
